import { useState } from "react";
import { itIT } from "@mui/x-data-grid-pro";
import { PersistentDataGridPro as DataGridPro } from "./PersistentDataGridPro";
import LinearProgress from "@mui/material/LinearProgress";
import { CustomFooterPersonalized } from "./CustomFooterPersonalized";

const VISIBILITY_PREFIX = "datagrid_col_visibility_";
const FILTER_PREFIX = "datagrid_filter_";

export const DataGridBase = ({
  storageKey,
  defaultHiddenColumns = {},
  slots = {},
  ...rest
}) => {
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => {
    if (!storageKey) return defaultHiddenColumns;
    const saved = localStorage.getItem(VISIBILITY_PREFIX + storageKey);
    return saved ? JSON.parse(saved) : defaultHiddenColumns;
  });

  const [filterModel, setFilterModel] = useState(() => {
    if (!storageKey) return { items: [] };
    const saved = sessionStorage.getItem(FILTER_PREFIX + storageKey);
    return saved ? JSON.parse(saved) : { items: [] };
  });

  const handleColumnVisibilityChange = (newModel) => {
    setColumnVisibilityModel(newModel);
    if (storageKey) {
      localStorage.setItem(
        VISIBILITY_PREFIX + storageKey,
        JSON.stringify(newModel)
      );
    }
  };

  const handleFilterModelChange = (newModel) => {
    setFilterModel(newModel);
    if (storageKey) {
      sessionStorage.setItem(
        FILTER_PREFIX + storageKey,
        JSON.stringify(newModel)
      );
    }
  };

  return (
    <DataGridPro
      persistenceKey={storageKey}
      density="compact"
      localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
      slots={{
        loadingOverlay: LinearProgress,
        footer: CustomFooterPersonalized,
        ...slots,
      }}
      columnVisibilityModel={columnVisibilityModel}
      onColumnVisibilityModelChange={handleColumnVisibilityChange}
      filterModel={filterModel}
      onFilterModelChange={handleFilterModelChange}
      {...rest}
    />
  );
};
